import React from 'react';
import { Rocket, Database, MessageSquare, Code2, Zap, Globe } from 'lucide-react';

const PoweredBySection = () => {
  const technologies = [
  {
    name: 'Rocket.new',
    icon: Rocket,
    color: 'text-rose-500'
  },
  {
    name: 'Supabase',
    icon: Database,
    color: 'text-green-500'
  },
  {
    name: 'ChatGPT',
    icon: MessageSquare,
    color: 'text-gray-800'
  },
  {
    name: 'React',
    icon: Code2,
    color: 'text-blue-500'
  },
  {
    name: 'Tailwind CSS',
    icon: Zap,
    color: 'text-cyan-500'
  },
  {
    name: 'OpenAI API',
    icon: Globe,
    color: 'text-purple-500'
  }];


  // Duplicate the array for seamless infinite scroll
  const duplicatedTechnologies = [...technologies, ...technologies, ...technologies];

  return (
    <section className="py-12 bg-gradient-to-b from-background to-muted/20 overflow-hidden pt-2.5 pb-0">
      <div className="py-16 bg-gradient-to-br from-green-50 to-blue-50 pt-2.5 pb-0">
        {/* Section Header */}
        <div className="text-center mb-8 px-4">
          <h2 className="text-2xl font-bold text-foreground mb-1">
            Powered By
          </h2>
          <p className="text-sm text-muted-foreground">Technologies used to empower ParkTrip Planner AI

          </p>
        </div>

        {/* Infinite Scrolling Ribbon */}
        <div className="relative bg-gradient-to-r from-green-900/90 via-green-800/90 to-green-900/90 py-6 backdrop-blur-sm">
          {/* Gradient Overlays for Fade Effect */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-green-900/90 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-green-900/90 to-transparent z-10 pointer-events-none" />
          
          {/* Scrolling Container */}
          <div className="flex animate-scroll">
            {duplicatedTechnologies?.map((tech, index) => {
              const IconComponent = tech?.icon;
              return (
                <div
                  key={`${tech?.name}-${index}`}
                  className="flex items-center justify-center mx-8 flex-shrink-0">

                  {/* Logo and Name Container */}
                  <div className="flex items-center gap-3 px-6 py-2 rounded-lg bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-all duration-300">
                    <IconComponent
                      className={`${tech?.color} w-8 h-8`}
                      strokeWidth={2} />

                    <span className="text-white font-semibold text-lg whitespace-nowrap">
                      {tech?.name}
                    </span>
                  </div>
                </div>);

            })}
          </div>
        </div>
      </div>

      {/* Custom Animation Styles */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
        
        .animate-scroll {
          animation: scroll 30s linear infinite;
          width: fit-content;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>);

};

export default PoweredBySection;